import { createAction } from '@reduxjs/toolkit';

export const dataPointersUpdate = createAction('dataPointersUpdate');

export const removeDataPointers = createAction('removeDataPointers');
